import { usePermissions } from "components/context/permissionsContext";

export const usePropertyAreaPermission = () => {
  const { userPermissions } = usePermissions();

  const hasPropertyAreaSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "PropertyArea" &&
      item.action === "SavePropertyArea" &&
      item.hasPermission
  );
  const hasPropertyAreaGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "PropertyArea" &&
      item.action === "GetPropertyArea" &&
      item.hasPermission
  );
  const hasPropertyAreaDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "PropertyArea" &&
      item.action === "DeletePropertyArea" &&
      item.hasPermission
  );

  const PropertyAreaPermissionProps = {
    hasPropertyAreaSavePermission,
    hasPropertyAreaGetPermission,
    hasPropertyAreaDeletePermission,
  };

  return {
    PropertyAreaPermissionProps,
  };
};
